import { Button, Toast } from '../../design'
import { LIVE_COPY } from './copy'
import type { LiveToastState } from './useLiveAlerts'

export interface LiveToastProps {
  toast: LiveToastState | null
  onDismiss: () => void
  onOpen: (conversationId: string) => void
}

export const LiveToast = ({ toast, onDismiss, onOpen }: LiveToastProps) => {
  if (toast === null) return null

  const open = () => {
    onOpen(toast.conversationId)
    onDismiss()
  }

  return (
    <Toast
      key={toast.key}
      title={LIVE_COPY.toastTitle}
      detail={LIVE_COPY.toastDetail}
      action={
        <Button variant="primary" onClick={open}>
          {LIVE_COPY.view}
        </Button>
      }
      onDismiss={onDismiss}
    />
  )
}
